var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"microbiology-main-view"},[_c('Microbiology')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }